import { format, parseISO } from 'date-fns';

export const findSectionById = (fieldsList, id) => {
  return fieldsList.find((section) => section.id === id);
};

export const formatDateForInput = (dateString) => {
  if (!dateString) return ''; // Return empty string if no date is provided
  try {
    return format(parseISO(dateString), 'yyyy-MM-dd'); // Format to "yyyy-MM-dd"
  } catch (error) {
    console.error('Error formatting date:', error);
    return ''; // Return empty string on format error
  }
};

export const validateFields = (formData, FieldsList, isAddMode = false) => {
  const errors = {};
  
  // Check if FieldsList is defined and contains sections
  if (!FieldsList || FieldsList.length === 0) {
    console.error('FieldsList is undefined or empty');
    return errors;  // Return empty error object if no fields are present
  }

  FieldsList.forEach((section) => {
    if (section.fields) {
      section.fields.forEach((field) => {
        const value = formData[field.key] || '';
        
        // Check required fields
        if (field.required && !value.trim()) {
          // Skip password fields if not in add mode
          if (!isAddMode && (field.key === 'password' || field.key === 'confirmPassword')) {
            return;
          }
          errors[field.key] = `${field.label} is required.`;
        }

        // Check email format
        if (field.type === 'email' && value && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          errors[field.key] = 'Please enter a valid email address.';
        }

        // Limit phone fields to a maximum of 12 characters
        if (field.type === 'text' && field.key.includes('phone') && value.length > 12) {
          errors[field.key] = 'Phone number cannot exceed 12 characters.';
        }
      });
    }
  });

  console.log('Validation errors:', errors); // Log the errors for debugging
  return errors;
};



// Format phone number (no change needed here for character limit)
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Return the phone number as is, no special formatting required
  return phone;
};
